import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const baseUrl = (process.env.NEXT_PUBLIC_BASE_URL || 'https://marjorysophrologie.com').replace(/\/$/, '');

export function absoluteUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalized}`;
}

export function canonicalUrl(path: string): string {
  if (path === '/' || path === '') return absoluteUrl('/');
  const withLeading = path.startsWith('/') ? path : `/${path}`;
  const withSlash = withLeading.endsWith('/') ? withLeading : `${withLeading}/`;
  return absoluteUrl(withSlash);
}